import { z } from "zod";

import {
  DatePickerField,
  InputField,
  SelectField,
} from "@/features/FormCard/Fields";

import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";

import { parseDate } from "@/lib/utils";

import { choice_yes_no } from "@/data/choice.ts";
import { EditForm } from "@/features/Edit/types.ts";
import i18n from "@/i18n";

type SubmittedData = {
  [key: string]: any;
};

type AdjustedData = {
  [key: string]: any;
};

export const a7FIAInstrumentTSEditForm: EditForm = {
  table_name: "a7_fia_instrument_ts",
  fieldsNotApplyTranslation: ["subordination", "restructuration"],
  formSchema: z.object({
    date: z.preprocess((val) => parseToDateValue(val as string), dateSchema),
    a7_fia_instrument_id: z.coerce.number().int(),
    subordination: z.string().optional().nullable(),
    restructuration: z.string().optional().nullable(),
  }),
  adjustData: (submittedData: SubmittedData): AdjustedData => ({
    ...submittedData,
    date: parseDate(submittedData.date),
  }),
  formBodyContent: (form, multiFieldOptions) => (
    <>
      <div className=" grid grid-cols-1 md:grid-cols-4 gap-2">
        <DatePickerField
          name="date"
          label={i18n.t("a7_fia_instrument_ts.columns.date", {
            ns: "tables",
            defaultValue: "Date",
          })}
          isRequired={true}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
        <InputField
          name="a7_fia_instrument_id"
          label={i18n.t("a7_fia_instrument_ts.columns.a7_fia_instrument_id", {
            ns: "tables",
            defaultValue: "Financial instrument",
          })}
          isRequired={true}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>
      <div className=" grid grid-cols-1 md:grid-cols-2 gap-2">
        <SelectField
          name="subordination"
          label={i18n.t("a7_fia_instrument_ts.columns.subordination", {
            ns: "tables",
            defaultValue: "Subordination",
          })}
          options={choice_yes_no.map((c) => ({
            value: c.value,
            label: c.value,
          }))}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
        <SelectField
          name="restructuration"
          label={i18n.t("a7_fia_instrument_ts.columns.restructuration", {
            ns: "tables",
            defaultValue: "Restructuring",
          })}
          options={choice_yes_no.map((c) => ({
            value: c.value,
            label: c.value,
          }))}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>
    </>
  ),
};
